import { memo, useMemo } from "react";
import styles from "./InlineSpinner.module.css";

export interface InlineSpinnerProps {
	size?: number;
	className?: string;
	/** White spinner for primary/dark button backgrounds */
	inverse?: boolean;
}

export const InlineSpinner = memo(({ size = 32, className = "", inverse = false }: InlineSpinnerProps) => {
	const style = useMemo(() => {
		const borderWidth = Math.max(2, Math.floor(size * 0.1));
		return { width: size, height: size, borderWidth };
	}, [size]);

	return (
		<div
			className={`${inverse ? styles.inverse : styles.root} ${className}`}
			style={style}
			role="progressbar"
			aria-label="Loading"
		/>
	);
});

InlineSpinner.displayName = "InlineSpinner";
